import React, { useState,useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  ButtonGroup,
} from "@mui/material";
import { ShoppingCart, Inventory, Store } from "@mui/icons-material";
import AppHeaderBar from "../../components/AppBar/appBar";
import NotificationSettings from "./NotificationSettings";
import CompanyTiming from "./CompanyTiming";
import AdminRole from "./AdminRole";
import Adminsiteorder from "./Adminsiteorder";
import Adminregularorder from "./Adminregularorder";
import Adminlistingorder from "./Adminlistingorder";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const AdminOrderManagement = ({onBackScreenName}) => {
   const [value, setValue] = useState(0);

    const handleScreeName = (sname) => {
      onBackScreenName(sname);
    };
 useEffect(() => {
  document.title = "Sthanick | Order Management";
}, []);


  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          // Hide scrollbar
          "&::-webkit-scrollbar": {
            display: "none", // For Chrome, Safari, and Edge
          },
          msOverflowStyle: "none", // For Internet Explorer and Edge
          scrollbarWidth: "none", // For Firefox
        }}
      >
        

        <AppHeaderBar
          title={"Order Management"}
          onBackScreenName={handleScreeName}
        />

        <Box
          sx={{
            display: "flex",
            gap: 2,
            mb: 3,
            mt: 2,
            flexWrap: "wrap",
          }}
        >
          <Button
            variant={value === 0 ? "contained" : "outlined"}
            onClick={() => setValue(0)}
            startIcon={<Store />}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: "12px",
              textTransform: "none",
              fontSize: "16px",
              fontWeight: value === 0 ? 600 : 500,
              boxShadow: value === 0 ? "0 4px 12px rgba(99, 102, 241, 0.3)" : "none",
              background: value === 0
                ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                : "transparent",
              border: value === 0 ? "none" : "2px solid #e0e7ff",
              color: value === 0 ? "#fff" : "#4f46e5",
              "&:hover": {
                background: value === 0
                  ? "linear-gradient(135deg, #5568d3 0%, #6a4190 100%)"
                  : "#eef2ff",
                transform: "translateY(-2px)",
                boxShadow: value === 0
                  ? "0 6px 16px rgba(99, 102, 241, 0.4)"
                  : "0 2px 8px rgba(99, 102, 241, 0.15)",
              },
              transition: "all 0.3s ease",
            }}
          >
            Site Admin Order
          </Button>

          <Button
            variant={value === 1 ? "contained" : "outlined"}
            onClick={() => setValue(1)}
            startIcon={<ShoppingCart />}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: "12px",
              textTransform: "none",
              fontSize: "16px",
              fontWeight: value === 1 ? 600 : 500,
              boxShadow: value === 1 ? "0 4px 12px rgba(99, 102, 241, 0.3)" : "none",
              background: value === 1
                ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                : "transparent",
              border: value === 1 ? "none" : "2px solid #e0e7ff",
              color: value === 1 ? "#fff" : "#4f46e5",
              "&:hover": {
                background: value === 1
                  ? "linear-gradient(135deg, #5568d3 0%, #6a4190 100%)"
                  : "#eef2ff",
                transform: "translateY(-2px)",
                boxShadow: value === 1
                  ? "0 6px 16px rgba(99, 102, 241, 0.4)"
                  : "0 2px 8px rgba(99, 102, 241, 0.15)",
              },
              transition: "all 0.3s ease",
            }}
          >
            Regular Order
          </Button>

          <Button
            variant={value === 2 ? "contained" : "outlined"}
            onClick={() => setValue(2)}
            startIcon={<Inventory />}
            sx={{
              px: 3,
              py: 1.5,
              borderRadius: "12px",
              textTransform: "none",
              fontSize: "16px",
              fontWeight: value === 2 ? 600 : 500,
              boxShadow: value === 2 ? "0 4px 12px rgba(99, 102, 241, 0.3)" : "none",
              background: value === 2
                ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                : "transparent",
              border: value === 2 ? "none" : "2px solid #e0e7ff",
              color: value === 2 ? "#fff" : "#4f46e5",
              "&:hover": {
                background: value === 2
                  ? "linear-gradient(135deg, #5568d3 0%, #6a4190 100%)"
                  : "#eef2ff",
                transform: "translateY(-2px)",
                boxShadow: value === 2
                  ? "0 6px 16px rgba(99, 102, 241, 0.4)"
                  : "0 2px 8px rgba(99, 102, 241, 0.15)",
              },
              transition: "all 0.3s ease",
            }}
          >
            Listing Order
          </Button>
        </Box>

        <TabPanel value={value} index={0}>
          <Adminsiteorder />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Adminregularorder />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Adminlistingorder />
        </TabPanel>
       
      </Box>
    </Box>
  );
};

export default AdminOrderManagement;
